<template>
  <b-card no-body class="watchlist-color w-100 mt-1">
    <b-card-body class="d-flex flex-column p-0">
      <div class="watchlist-header">
        <img
          src="@/assets/images/portfolio/PrimeWatchlist.svg"
          alt="1"
          class="watchlist-image"
        />
        <h4 class="card-title watchlist-name">
          {{ showSingleTab !== null ? (showSingleTab === 0 ? 'Stock Watchlist' : 'Mutual Fund Watchlist') : 'Your Watchlist' }}
        </h4>
      </div>
      <div class="g-asaloc-tab2-nav" v-if="showSingleTab === null">
        <div
          v-for="(tab, index) in visibleTabs"
          :key="index"
          class="g-asaloc-tab2-nav-item"
          :class="{ active: showSingleTab !== null ? showSingleTab === tab.originalIndex : activeTab === tab.originalIndex }"
          @click="selectTab(tab.originalIndex)"
        >
          <div class="g-asaloc-tab2-nav-title">
            {{ tab.title }}
            <span v-if="(showSingleTab !== null ? showSingleTab !== tab.originalIndex : activeTab !== tab.originalIndex)" class="count-badge">{{
              tab.alert_count
            }}</span>
          </div>
        </div>
      </div>
      <div class="tab-content-wrapper" ref="tabContentWrapper">
        <div
          v-for="(tab, index) in displayTabs"
          :key="showSingleTab !== null ? showSingleTab : index"
          :id="`tab${showSingleTab !== null ? showSingleTab : index}`"
          class="tab-content"
          :class="{ active: showSingleTab !== null ? true : activeTab === index }"
        >
          <div
            class="activity-feed mb-0"
            :class="{
              'watchlist-simplebar-prp':
                isPortfolioEmpty &&
                (planType === 'Prime-registered' || planType === 'Active' || planType === 'Prime Trial' ||planType === 'Prime Trial' ||
                    planType === 'Trial Expired' ||
                    planType === 'Subscription expired'),
              'watchlist-simplebar':
                !isPortfolioEmpty 
            }"
            data-simplebar
          >
            <div
              v-for="item in tab.items"
              :key="item.id"
              class="mt-3"
              @click="openLink(item, tab.title)"
              :class="['content-div', { 'stocks-cursor': isStocksTabActive }]"
              placement="right"
            >
              <p
                class="item-name d-flex justify-content-between align-items-center"
                :title="getTabIndex(index) === 1 ? item?.name : ''"
                v-b-tooltip.hover="getTabIndex(index) === 1 ? 'item.name' : null"
              >
                {{ getTabIndex(index) === 1 ? truncateText(item.name, 37) : item.name }}
                <span v-if="getTabIndex(index) != 2 && item.alertcount != 0">
                  <a
                    :href="`${baseURL}/prime-watchlist/`"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fa-solid fa-bell bell-icon"></i>
                    <span
                      class="translate-middle badge rounded-circle bg-danger custom-badge"
                    >
                      {{ item.alertcount }}
                    </span>
                  </a>
                </span>
              </p>
              <span v-if="getTabIndex(index) === 2" class="item-action">{{
                item.action
              }}</span>
              <div>
                <div
                  v-if="tab.title === 'Your Portfolios'"
                  class="returns-portfolio"
                >
                  <div class="header-row" v-if="getTabIndex(index) === 2">
                    <span class="text-start">Since inception</span>
                    <span class="text-center">3M Return</span>
                    <span class="text-end">1Y Return</span>
                  </div>
                  <div class="value-row" v-if="getTabIndex(index) === 2">
                    <span
                      v-if="getTabIndex(index) === 2 || getTabIndex(index) === 1"
                      :class="{
                        positive: parseFloat(item.creation) > 0,
                        negative: parseFloat(item.creation) < 0,
                      }"
                      class="text-start"
                      >{{ item.creation }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.three_return) > 0,
                        negative: parseFloat(item.three_return) < 0,
                      }"
                      class="text-center"
                      >{{ item.three_return }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.one_return) > 0,
                        negative: parseFloat(item.one_return) < 0,
                      }"
                      class="text-end"
                      >{{ item.one_return }}</span
                    >
                  </div>
                </div>
                <div v-else class="returns">
                  <div
                    :class="['header-row', { 'small-font': isMobile }]"
                    v-if="getTabIndex(index) === 1"
                  >
                    <span class="text-start">Rating & Call</span>
                    <span class="text-center">3M Return</span>
                    <span class="text-end">1Y Return</span>
                  </div>
                  <div class="header-row" v-else>
                    <span class="text-start">CMP</span>
                    <span class="text-center">Mcap(Cr)</span>
                    <span class="text-end">1-Day chg</span>
                  </div>
                  <div class="value-row" v-if="getTabIndex(index) === 1">
                    <span
                      class="text-start"
                      :class="{
                        'bg-green': item.currentCall === 'Buy',
                        'bg-red': item.currentCall === 'Sell',
                      }"
                      v-if="getTabIndex(index) === 2 || getTabIndex(index) === 1"
                      >{{ item.creation }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.three_return) > 0,
                        negative: parseFloat(item.three_return) < 0,
                      }"
                      class="text-center"
                      >{{ item.three_return }}</span
                    >
                    <span
                      :class="{
                        positive: parseFloat(item.one_return) > 0,
                        negative: parseFloat(item.one_return) < 0,
                      }"
                      class="text-end"
                      >{{ item.one_return }}</span
                    >
                  </div>
                  <div class="value-row" v-else>
                    <span class="text-start"
                      >{{ item.current_market_price }}
                    </span>
                    <span class="text-center">{{ item.market_cap }}</span>
                    <span
                      :class="{
                        positive: parseFloat(item.oneday_return) > 0,
                        negative: parseFloat(item.oneday_return) < 0,
                      }"
                      class="text-end"
                      v-if="tab.title === 'Stocks'"
                      >{{ item.oneday_return }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <a
              v-if="viewAllText()"
              :href="viewAllText().url"
              target="_blank"
              rel="noopener noreferrer"
              class="view-funds-link d-flex justify-content-center"
              >{{ viewAllText().text }}</a
            >
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
  <SubscriptionExpiredModal ref="expiredModal" />
</template>

<script>
import SimpleBar from "simplebar";
import { mapGetters } from "vuex";
import SubscriptionExpiredModal from "./SubcriptionExpiredModal";

export default {
  name: "ActivityList",
  components: {
    SubscriptionExpiredModal,
  },
  props: {
    showSingleTab: {
      type: Number,
      default: null, // null means show both tabs, 0 for Stocks, 1 for Mutual Funds
    },
  },
  data() {
    return {
      activeTab: 0,
      jsonData: null,
      isMobile: window.innerWidth < 400,
      baseURL: process.env.VUE_APP_BASE_URL,
      tabs: [
        {
          title: "Stocks",
          items: [],
          alert_count: 0,
        },
        {
          title: "Mutual Funds",
          items: [],
          alert_count: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["watchlist", "subscriptionType", "myPortfolio", "planType", "userProfile"]),
    isPortfolioEmpty() {
      return Object.keys(this.myPortfolio).length === 0;
    },
    isStocksTabActive() {
      return this.activeTab === 0 || this.activeTab === 1;
    },
    isMutualFunds() {
      return this.tabtitle === "Mutual Funds";
    },
    displayTabs() {
      if (this.showSingleTab !== null) {
        return [this.tabs[this.showSingleTab]];
      }
      return this.tabs;
    },
    visibleTabs() {
      if (this.showSingleTab !== null) {
        return [{
          ...this.tabs[this.showSingleTab],
          originalIndex: this.showSingleTab
        }];
      }
      return this.tabs.map((tab, index) => ({
        ...tab,
        originalIndex: index
      }));
    },
  },
  methods: {
    getTabIndex(displayIndex) {
      return this.showSingleTab !== null ? this.showSingleTab : displayIndex;
    },
    viewAllLink() {
      if (
        this.tabs.length === 0 ||
        this.activeTab < 0 ||
        this.activeTab >= this.tabs.length
      ) {
        return null;
      }
      const tabTitle = this.tabs[this.activeTab].title;
      const baseURL = process.env.VUE_APP_BASE_URL;

      if (tabTitle === "Your Portfolios") {
        return {
          text: "View all your portfolios",
          url: `${baseURL}/build-your-own-portfolio/list/`,
        };
      } else if (tabTitle === "Mutual Funds") {
        return {
          text: "View full watchlist",
          url: `${baseURL}/prime-watchlist/?wc=mf`,
        };
      } else {
        return {
          text: "View full watchlist",
          url: `${baseURL}/prime-watchlist`,
        };
      }
    },
    viewAllText() {
      const link = this.viewAllLink();
      return link ? link : { text: "Default Text" };
    },
    openLink(item, tabTitle) {
      const baseURL = process.env.VUE_APP_BASE_URL;
      let url = "";
      if (tabTitle === "Mutual Funds") {
        url = `${baseURL}/prime-watchlist/?wc=mf`;
        window.open(url, "_blank");
      } else if (tabTitle === "Stocks") {
        url = `${baseURL}/prime-watchlist`;
        window.open(url, "_blank");
      }
    },
    truncateText(text, maxLength) {
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    },
    selectTab(index) {
      this.$nextTick(() => {
        if (this.subscriptionType === "sub-expired" && index !== 0) {
          if (this.$refs.expiredModal) {
            this.$refs.expiredModal.showModal();
          } else {
            console.error(
              "SubscriptionExpiredModal reference is not available."
            );
          }
        } else {
          this.activeTab = index;
        }
      });
    },
    calculateTotalAlertCount(items) {
      return items.reduce(
        (total, item) => total + (parseInt(item.alertcount) || 0),
        0
      );
    },
    processFetchedData(data) {
      try {
        if (Object.keys(data).length > 0) {
          this.tabs[0].items = data.stock_watch.map((stock, index) => ({
            id: index + 1,
            name: stock.company_name,
            action: `Alerts: ${stock.alertCount}`,
            oneday_return: `${
              parseFloat(stock.oneDayChangePercentage).toFixed(1)
                ? (parseFloat(stock.oneDayChangePercentage).toFixed(1) >= 0
                    ? "+"
                    : "") + parseFloat(stock.oneDayChangePercentage).toFixed(1)
                : "0"
            }%`,
            current_market_price: `${
              parseFloat(stock.currentMarketPrice) >= 0 ? "₹" : ""
            } ${stock.currentMarketPrice}`,
            three_return: `${
              parseFloat(stock.oneYearReturnPercentage) !== 0
                ? (parseFloat(stock.oneYearReturnPercentage).toFixed(1) > 0
                    ? "+"
                    : "") + parseFloat(stock.oneYearReturnPercentage).toFixed(1)
                : "NA"
            }${parseFloat(stock.oneYearReturnPercentage) !== 0 ? "(%)" : ""}`,
            market_cap: `₹ ${stock.marketCap}`,
            alertcount: `${stock.alertCount}`,
            co_code: `${stock.co_code}`,
          }));

          this.tabs[1].items = data.mf_watch.map((fund, index) => ({
            id: index + 1,
            name: fund.scheme_name,
            creation: `${
              fund.currentRating === "0" ? "NA" : `★ ${fund.currentRating}`
            } | ${fund.currentCall}`,
            one_return: `${
              parseFloat(fund.oneYearReturnPercentage) !== 0
                ? (parseFloat(fund.oneYearReturnPercentage).toFixed(1) > 0
                    ? "+"
                    : "") + parseFloat(fund.oneYearReturnPercentage).toFixed(1)
                : "NA"
            }${parseFloat(fund.oneYearReturnPercentage) !== 0 ? "(%)" : ""}`,
            three_return: `${
              parseFloat(fund.threeYearReturnPercentage) !== 0
                ? (parseFloat(fund.threeYearReturnPercentage).toFixed(1) > 0
                    ? "+"
                    : "") +
                  parseFloat(fund.threeYearReturnPercentage).toFixed(1)
                : "NA"
            }${parseFloat(fund.threeYearReturnPercentage) !== 0 ? "(%)" : ""}`,
            alertcount: `${fund.alertCount}`,
          }));

          let totalmfAlertCount = this.calculateTotalAlertCount(
            this.tabs[1].items
          );
          this.tabs[1].alert_count =
            totalmfAlertCount === 0 ? "" : totalmfAlertCount;
          let totaleqAlertCount = this.calculateTotalAlertCount(
            this.tabs[0].items
          );
          this.tabs[0].alert_count =
            totaleqAlertCount === 0 ? "" : totaleqAlertCount;
        }
      } catch (error) {
        console.error("Error processing data:", error);
      }
    },
    getMarketPriceClass(oneDayChangePercentage) {
      return parseFloat(oneDayChangePercentage) >= 0 ? "positive" : "negative";
    },
  },
  watch: {
    watchlist: {
      handler(newValue) {
        this.processFetchedData(newValue);
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.showSingleTab !== null) {
      this.activeTab = this.showSingleTab;
    }
    this.$nextTick(() => {
      if (this.$refs.tabContentWrapper) {
        const simplebarElement = this.$refs.tabContentWrapper.querySelector("[data-simplebar]");
        if (simplebarElement) {
          new SimpleBar(simplebarElement);
        }
      }
    });
  },
};
</script>

<style scoped>
.watchlist-color {
  background: linear-gradient(rgb(255, 255, 255) 0%, rgb(204, 241, 238) 100%);
}

.custom-badge {
  font-size: 6px;
  padding: 3px 4px;
  position: absolute;
}

.watchlist-header {
  position: relative;
  padding: 10px;
}

.small-font {
  font-size: 10px !important;
}

.watchlist-image {
  position: relative;
  top: 5px;
  left: 6px;
  height: 35px;
  width: 30px;
}

.watchlist-name {
  position: absolute;
  left: 54px;
  top: 22px;
}

.watchlist-simplebar-prp {
  height: 642px;
  margin-top: -10px;
  padding-left: 1rem;
  padding-right: 0.5rem;
}

.bell-icon {
  color: #7768ae;
}

.watchlist-simplebar {
  max-height: 255px;
  margin-top: -10px;
  padding-left: 1rem;
  padding-right: 0.5rem;
}

.header-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
}

.tooltip {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.tooltip.bs-tooltip-auto[x-placement^="right"] .arrow::before,
.tooltip .arrow:after {
  border-right-color: #333 !important;
}

.tooltip-inner {
  background-color: #333 !important;
  color: #fff !important;
  font-size: 12px;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.value-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 100;
  font-size: 14px;
}

.header-row span,
.value-row span {
  text-align: center;
  flex: 1;
}

.header-row span.text-start,
.value-row span.text-start {
  text-align: left;
}

.header-row span.text-end,
.value-row span.text-end {
  text-align: right;
}

.g-asaloc-tab2-nav {
  display: flex;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  padding-bottom: 7px;
}

.g-asaloc-tab2-nav-item {
  flex: 1;
  cursor: pointer;
  text-align: center;
  padding: 5px 0;
  position: relative;
  border: 1px solid #00a3d9;
  border-radius: 0;
}

.g-asaloc-tab2-nav-item:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.g-asaloc-tab2-nav-item:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.g-asaloc-tab2-nav-item.active {
  background-color: #00a3d9;
  color: white;
  border-bottom: none;
}

.g-asaloc-tab2-nav-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.count-badge {
  background-color: #dd2e44;
  color: white;
  padding: 0px 3px;
  border-radius: 4px;
  margin-left: 5px;
  font-size: 10px;
}

.tab-content-wrapper {
  flex-grow: 1;
  padding: 10px;
  overflow: hidden;
}

.tab-content {
  display: none;
}

.tab-content.active {
  display: block;
}

.content-div {
  width: 100%;
  background: linear-gradient(
    266.35deg,
    rgba(0, 163, 217, 0.12) 0.11%,
    rgba(242, 242, 49, 0.12) 94.11%
  );
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 18px;
  margin-top: 14px;
  margin-left: -7px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.content-div:hover {
  box-shadow: 0px 4px 4px rgba(0.1, 0.1, 0.1, 0.5);
}

.stocks-cursor:hover {
  box-shadow: 0px 4px 4px rgba(0.1, 0.1, 0.1, 0.5);
  cursor: pointer;
}

.item-name {
  font-size: 14px;
  font-weight: 500;
  color: #000;
  margin-bottom: -1px;
}

.item-action {
  font-size: 14px;
  color: #555;
  margin-top: 4px;
}

.returns {
  margin-top: 8px;
  font-size: 14px;
}

.returns-header,
.returns-values {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

@media (max-width: 768px) {
  .g-asaloc-tab2-nav-item {
    padding: 5px 0;
    font-size: 12px;
  }

  .returns-header,
  .returns-values {
    font-size: 9px;
  }
}

.positive {
  color: green;
}

.negative {
  color: red;
}

.view-funds-link {
  color: #00a3d9;
}

.bg-green {
  background-color: #d4edda;
}

.bg-red {
  background-color: #f8d7da;
}

.returns-portfolio {
  margin-top: 5px;
  font-size: 14px;
}
</style>
